import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import StyledIframe from './Iframe.style';

const isMobile = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth <= 643;
  }
  return false;
};

const Iframe = ({ title, file, noRatio = false, width, height, mobileHeight, allow, ...props }) => {
  const [mobile, setMobile] = useState(isMobile());

  const onResize = () => {
    setMobile(isMobile());
  };

  useEffect(() => {
    window.addEventListener('resize', onResize);
    onResize();

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <StyledIframe {...props} noRatio={noRatio}>
      <iframe
        title={title || file}
        src={file}
        width={width}
        height={mobile && mobileHeight ? mobileHeight : height}
        allow={allow}
        allowFullScreen
      />
    </StyledIframe>
  );
};

Iframe.propTypes = {
  title: PropTypes.string,
  file: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  mobileHeight: PropTypes.number,
  noRatio: PropTypes.bool,
  allow: PropTypes.string
};

export default Iframe;
